import axiosWrapper from "common/axiosWrapper";

const baseUrl = "/api/webpush/admin";

export default class WebPushAdminService {
	static async getStats() {
		return await axiosWrapper.get(`${baseUrl}/stats`);
	}

	static async send(payload) {
		return await axiosWrapper.post(`${baseUrl}/send`, payload);
	}
}
